import createList from '../../with-list';

import endpoints from '../../../../config/endpoints';

const namespace = 'bannersContentList';

const { actions, selectors, reducers } = createList({
	namespace,
	url: endpoints.BANNERS.CONTENTS,
	perPage: 20
});

export { namespace, actions, selectors, reducers as default };


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/banners/content/list/index.js